import * as z from "zod";

export const getPostPurchaseProviderStatus = {
  name: "getPostPurchaseProviderStatus" as const,
  input: z.null(),
  output: z.object({ isPostPurchaseAppInUse: z.boolean() }),
};

export type GetPostPurchaseProviderStatusOutput = z.infer<
  typeof getPostPurchaseProviderStatus.output
>;
